export default __webpack_public_path__ + "static/media/Dansn_Glass_Door_Logo_Mockup.0f085808.jpg";